import { supabase } from '@/lib/supabase';

export interface TermsSections {
  sale_terms: string | null;
  returns_policy: string | null;
  general_notes: string | null;
}

export interface EffectiveTerms extends TermsSections {
  published: boolean;
  company_published?: boolean;
  terms_version?: number;
  client_terms_version?: number;
  has_special_terms?: boolean;
  updated_at?: string;
  accepted?: boolean;
  last_accepted_at?: string | null;
  last_accepted_by_type?: 'client' | 'agent' | null;
  last_accepted_by_name?: string | null;
}

export interface AcceptanceRow {
  client_id: string;
  client_name: string;
  b2b_allowed: boolean;
  has_special_terms: boolean;
  accepted_current: boolean;
  accepted_at: string | null;
  accepted_by_type: 'client' | 'agent' | null;
  accepted_by_name: string | null;
}

export const TERMS_SECTIONS: { key: keyof TermsSections; label: string }[] = [
  { key: 'sale_terms',     label: 'תנאי מכירה' },
  { key: 'returns_policy', label: 'מדיניות החזרות' },
  { key: 'general_notes',  label: 'הערות כלליות' },
];

export async function fetchEffectiveTerms(clientId: string): Promise<EffectiveTerms> {
  const { data, error } = await supabase.rpc('get_b2b_effective_terms', { p_client_id: clientId });
  if (error) throw error;
  if (!data || typeof data !== 'object') return { published: false, sale_terms: null, returns_policy: null, general_notes: null };
  return data as EffectiveTerms;
}

export async function acceptTerms(clientId: string): Promise<void> {
  const { error } = await supabase.rpc('accept_b2b_terms', { p_client_id: clientId });
  if (error) throw error;
}

export async function fetchAcceptanceList(companyId: string): Promise<AcceptanceRow[]> {
  const { data, error } = await supabase.rpc('get_b2b_terms_acceptance_list', { p_company_id: companyId });
  if (error) throw error;
  return Array.isArray(data) ? (data as AcceptanceRow[]) : [];
}

export function hasAnyTerms(t: Partial<TermsSections> | null | undefined): boolean {
  if (!t) return false;
  return TERMS_SECTIONS.some(s => (t[s.key] ?? '').trim() !== '');
}

export function formatAcceptance(at: string | null | undefined, type: string | null | undefined, name: string | null | undefined): string {
  if (!at) return '';
  const d = new Date(at);
  const when = `${d.toLocaleDateString('he-IL')} ${d.toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' })}`;
  const who = type === 'agent' ? `ע"י הסוכן ${name ?? ''}`.trim() : `ע"י הלקוח${name ? ` (${name})` : ''}`;
  return `${when} · ${who}`;
}
